import React from 'react';
import * as formik from 'formik';
import { Button, Row, Form, Col } from 'react-bootstrap';
import axios from 'axios';
import { weightGoalValidationSchema } from '../../../../validations/weightGoalValidation';
import classNames from 'classnames';
import { trackEvent } from '../../../../utils/analytics';
interface WeightGoalFormProps {
  onClose: (isAdded: boolean) => void;
  patientId: any;
}

const WeightGoalForm: React.FC<WeightGoalFormProps> = ({
  onClose,
  patientId
}) => {
  const { Formik, useFormik } = formik;
  const token = localStorage.getItem('token');
  const handleSubmit = async (values: any) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/clinic/goals`,
        {
          patient_id: patientId,
          type: 'weight',
          current_date: new Date().toISOString().split('T')[0],
          ...values
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

      trackEvent('goal_created', {
        goal_type: 'weight',
        actor_user_id: String(currentUser.id || ''),
        actor_user_name: `${currentUser.firstname || ''} ${
          currentUser.lastname || ''
        }`.trim(),
        actor_role:
          currentUser.role?.toLowerCase() === 'clinic'
            ? 'clinic admin'
            : currentUser.role || '',
        platform: 'web'
      });

      onClose(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Formik
      initialValues={{ target_value: '', current_value: '', target_date: '' }}
      validationSchema={weightGoalValidationSchema}
      onSubmit={handleSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        touched,
        errors,
        dirty,
        setValues
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row className={classNames('g-3')}>
            <Col>
              <Form.Group className="mb-2">
                <Form.Label>Current Weight (Kg)</Form.Label>
                <Form.Control
                  type="text"
                  name="current_value"
                  value={values.current_value}
                  onChange={handleChange}
                  isValid={touched.current_value && !errors.current_value}
                  isInvalid={touched.current_value && !!errors.current_value}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.current_value}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Target Weight (Kg)</Form.Label>
                <Form.Control
                  type="text"
                  name="target_value"
                  value={values.target_value}
                  onChange={handleChange}
                  isValid={touched.target_value && !errors.target_value}
                  isInvalid={touched.target_value && !!errors.target_value}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.target_value}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className={classNames('g-3')}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Target Date</Form.Label>
                <Form.Control
                  type="date"
                  name="target_date"
                  value={values.target_date}
                  onChange={handleChange}
                  min={
                    new Date(Date.now() + 24 * 60 * 60 * 1000)
                      .toISOString()
                      .split('T')[0]
                  }
                  isValid={touched.target_date && !errors.target_date}
                  isInvalid={touched.target_date && !!errors.target_date}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.target_date}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <div className="text-end mt-3 mb-3">
            <Button type="submit" variant="primary">
              Save Weight Goal
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default WeightGoalForm;
